import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link as RRRLink } from 'react-router-dom';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { ButtonDefault } from '../../helpers/UIElements';

const styles = css`
  height: 573px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media(min-width: 992px) {
    height: 650px;
  }
  .ModelsSection_boxWrapper {
    background-color: rgba(214, 155, 41, 0.85);
    padding: 30px;
    width: 100%;
    @media(min-width: 576px) {
      max-width: 488px;
    }
    @media(min-width: 992px) {
      padding: 50px 30px;
    }
  }
  .ModelsSection_title {
    font-weight: 900;
    font-size: 23px;
    color: #FFFFFF;
    letter-spacing: 1.95px;
    text-align: center;
    text-transform: uppercase;
    @media(min-width: 992px) {
      font-size: 30px;
      letter-spacing: 3px;
    }
  }
  .ModelsSection_subtitle {
    font-weight: 300;
    font-size: 32px;
    color: #FFFFFF;
    letter-spacing: 1px;
    text-align: center;
    line-height: auto;
    @media(min-width: 992px) {
      font-size: 79px;
      letter-spacing: -0.29px;
    }
  }
  .ModelsSection_btn {
    height: 38px;
    width: max-content;
    min-width: 216px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    transition: all .3s ease-out;
    @media (min-width: 768px) {
      height: 53px;
      margin-top: -25px;
    }
    @media (min-width: 992px) {
      padding: 30px
    }
    &:hover {
      transform: scale(1.05);
      box-shadow: rgba(0, 0, 0, 0.2) 0px 15px 20px 0px;
    }
    a {
      width: 253px;
    }
  }
  .ModelsSection_btn > ::after {
    right: 20px;
    @media (min-width: 992px) {
      right: 0;
    }
  }
`;

function ModelsSection({ content }) {
  return (
    <div className={styles} style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, 'image.contentUrl'), { width: 1500, height: 1500, preserve: true })})` }} >
      <hgroup className="ModelsSection_boxWrapper">
        <h3 className="ModelsSection_title">{get(content, 'title')}</h3>
        <h4 className="ModelsSection_subtitle mt-3">{get(content, 'subtitle')}</h4>
      </hgroup>
      {
        get(content, 'button_link') &&
        <div className="ModelsSection_btn">
          <ButtonDefault>
            <RRRLink to={get(content, 'button_link')}>
              {get(content, 'button_text')}
            </RRRLink>
          </ButtonDefault>
        </div>
      }
    </div>
  );
}

ModelsSection.propTypes = {
  content: PropTypes.object.isRequired,
};

export default ModelsSection;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/ModelsSection.js